import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, AppBar, Tabs, Tab, Typography, Badge } from '@mui/material';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`status-center-tabpanel-${index}`}
      aria-labelledby={`status-center-tab-${index}`}
      style={{
        display: value === index ? 'flex' : 'none',
        flexDirection: 'column',
        overflow: 'hidden',
        minHeight: 0,
        flex: 1,
      }}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value:    PropTypes.number.isRequired,
  index:    PropTypes.number.isRequired,
};

export default function StatusCenterTabs({
  tabs,
  initialIndex = 0,
  width = '100%',
  equipmentEno = 0,
  systemsOoo = 0,
}) {
  const theme = useTheme();
  const [value, setValue] = React.useState(initialIndex);

  const handleChange = (_, newValue) => setValue(newValue);

  return (
    <Box sx={{ bgcolor: 'background.paper', width, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }} className="status-center-tabs-container">
      <AppBar position="static" color="default" className='status-center-tabs-header'>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="inherit"
          variant="fullWidth"
          aria-label="status center tabs"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#FFFFFF'
            }
          }}
        >
          {tabs.map(({ label }, idx) => (
            <Tab
              key={idx}
              label={
                label ===  'Systems' ? 
                  <Badge
                    badgeContent={systemsOoo}
                    overlap="circular"
                    sx={{
                      '& .MuiBadge-badge': {
                        right: -15,
                        top:   8,
                        minWidth: 18,
                        height:   17,
                        borderRadius: '50%',
                        fontSize: '0.65rem',
                        backgroundColor:"var(--color-green)"       
                    },
                  }}
                >
                  {label}
                </Badge>
                : label }
             
              id={`status-center-tab-${idx}`}
              disableRipple={true}
              aria-controls={`status-center-tabpanel-${idx}`}
            />
          ))}
        </Tabs>
      </AppBar>

      {tabs.map(({ content }, idx) => {
        return (
          <TabPanel
            key={idx}
            value={value}
            index={idx}
            dir={theme.direction}
          >
            {value === idx ? content() : null}
          </TabPanel>
        );
    })}
    </Box>
  );
}

StatusCenterTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label:   PropTypes.string.isRequired,
      content: PropTypes.func.isRequired,
    })
  ).isRequired,

  /** Which tab is active first */
  initialIndex: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Number of equipment not in operation */
  equipmentEno: PropTypes.number,
  /** Number of systems out of operation */
  systemsOoo: PropTypes.number,
};
